module.exports = __webpack_public_path__ + "static/assis-cover-95205737a8127644689bb35e881a1d06.png";